import { render, staticRenderFns } from "./BotaoDescancelarItemAditivoApostila.vue?vue&type=template&id=2a8b7eac&scoped=true"
import script from "./BotaoDescancelarItemAditivoApostila.vue?vue&type=script&lang=js"
export * from "./BotaoDescancelarItemAditivoApostila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b7eac",
  null
  
)

export default component.exports